//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Actions
//  ----------------------------------------------------------------------------

//  -- Create log ----------------
export const setBookTranslationContent = (returnedPayload) => ({ type: ActionTypes.page_translations.set_book_translations , payload: returnedPayload  });
export const updateBookTranslations = (returnedPayload) => ({ type: ActionTypes.page_translations.update_book_translations, payload: returnedPayload });
export const removePageTranslations = (returnedPayload) => ({ type: ActionTypes.page_translations.remove_page_translations, payload: returnedPayload });


export const setBookGrammarContent = (returnedPayload) => ({ type: ActionTypes.grammar_content.set_book_grammar_content , payload: returnedPayload  });
export const updateBookGrammarContent = (returnedPayload) => ({ type: ActionTypes.grammar_content.update_book_grammar_content, payload: returnedPayload });
export const removeBookGrammarContent = (returnedPayload) => ({ type: ActionTypes.grammar_content.remove_book_grammar_content, payload: returnedPayload });
export const clearBookGrammarContent= () => ({ type: ActionTypes.grammar_content.clear_book_grammar_content });




export const setBookvocabContent = (returnedPayload) => ({ type: ActionTypes.vocab_content.set_book_vocab_content , payload: returnedPayload  });
export const updateBookvocabContent = (returnedPayload) => ({ type: ActionTypes.vocab_content.update_book_vocab_content, payload: returnedPayload });
export const removeBookvocabContent = (returnedPayload) => ({ type: ActionTypes.vocab_content.remove_book_vocab_content, payload: returnedPayload });
export const clearBookvocabContent= () => ({ type: ActionTypes.vocab_content.clear_book_vocab_content });







//  -- List logs ----------------

